import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnCashPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M18.665 11.5V8.86c0-2.639-1.518-3.77-3.795-3.77H6.794C4.518 5.09 3 6.22 3 8.86v5.28c0 2.639 1.518 3.77 3.794 3.77h8.076c.617 0 1.179-.083 1.67-.257M5.9 9.615v3.77m9.865-3.77v3.77m1.847 2.081H21m-1.694-1.694v3.388m-6.198-5.66a2.27 2.27 0 0 1-2.276 2.262A2.27 2.27 0 0 1 8.556 11.5a2.27 2.27 0 0 1 2.276-2.263 2.27 2.27 0 0 1 2.276 2.263"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnCashPlus;
